import { render, staticRenderFns } from "./AddFile.vue?vue&type=template&id=49289227&scoped=true"
import script from "./AddFile.vue?vue&type=script&lang=js"
export * from "./AddFile.vue?vue&type=script&lang=js"
import style0 from "./AddFile.vue?vue&type=style&index=0&id=49289227&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49289227",
  null
  
)

export default component.exports